import React, { useRef, useEffect } from 'react';
import CalendarEvent from './CalendarEvent';
import { minutesToTop } from './timeUtils';

export default function DayColumn({
  dayMeta,
  events,
  layouts,
  selectedIds,
  interaction,
  nowMinutes,
  isMobileHidden,
  columnRefs,
  slotHover,
  dragSelect,
  onColumnPointerDown,
  onColumnPointerMove,
  onColumnPointerLeave,
  onEventPointerDown,
  onEventContextMenu,
  onResizePointerDown,
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (!columnRefs) return undefined;
    const refs = columnRefs.current;
    refs[dayMeta.day] = ref.current;
    return () => {
      refs[dayMeta.day] = null;
    };
  }, [columnRefs, dayMeta.day]);

  const showNow = dayMeta.today && Number.isFinite(nowMinutes);

  return (
    <div
      ref={ref}
      className={`day-column relative h-full${dayMeta.today ? ' bg-primary/5' : ''}${
        dayMeta.weekend ? ' bg-background-light/40' : ''
      }${isMobileHidden ? ' is-mobile-hidden' : ''}${
        dragSelect?.day === dayMeta.day && dragSelect?.preview ? ' is-dragging' : ''
      }`}
      data-day={dayMeta.day}
      data-day-label={dayMeta.label}
      data-date={dayMeta.date}
      data-iso={dayMeta.iso}
      onPointerDown={(e) => onColumnPointerDown?.(e, dayMeta.day)}
      onPointerMove={(e) => onColumnPointerMove?.(e, dayMeta.day)}
      onPointerLeave={() => onColumnPointerLeave?.(dayMeta.day)}
    >
      <div
        className="slot-hover"
        style={
          slotHover?.day === dayMeta.day
            ? { top: `${slotHover.top}px`, opacity: 1 }
            : undefined
        }
      />
      <div
        className="drag-select"
        style={
          dragSelect?.day === dayMeta.day
            ? {
                display: 'block',
                top: `${dragSelect.top}px`,
                height: `${dragSelect.height}px`,
              }
            : undefined
        }
      />
      {events.map((ev) => (
        <CalendarEvent
          key={ev.segmentKey || ev.id}
          event={ev}
          layout={layouts[ev.segmentKey || ev.id]}
          selected={selectedIds.has(ev.id)}
          isMoving={interaction?.type === 'move' && interaction.ids?.includes(ev.id)}
          isResizing={interaction?.type === 'resize' && interaction.id === ev.id}
          isCopySource={interaction?.type === 'copy' && interaction.sourceId === ev.id}
          onPointerDown={(e) => onEventPointerDown?.(e, ev)}
          onContextMenu={(e) => onEventContextMenu?.(e, ev)}
          onResizePointerDown={(e) => onResizePointerDown?.(e, ev)}
        />
      ))}
      {showNow ? (
        <div className="current-time-line" style={{ top: `${minutesToTop(nowMinutes)}px` }}>
          <div className="current-time-dot" />
        </div>
      ) : null}
    </div>
  );
}
